export const en = {
  lang: "en",
  path: "/",
  meta: {
    title: "GetTaxcy - Taxi & Airport Transfers in Cyprus | Paphos, Larnaca, Ercan",
    description:
      "GetTaxcy is the taxi app for Cyprus by Costataxicy, Paphos. Fixed-price taxis and airport transfers from Larnaca, Paphos and Ercan, 24/7 across the island. Book on WhatsApp +357 99940234.",
    locale: "en_GB",
  },
  switcher: { href: "/el", label: "ΕΛ", aria: "Ελληνικά" },
  nav: [
    { href: "#services", label: "Ride" },
    { href: "#airport", label: "Airport" },
    { href: "#business", label: "Business" },
    { href: "#faq", label: "FAQ" },
  ],
  getApp: "Get the app",
  help: "Help",
  bookWhatsapp: "Book on WhatsApp",
  bookShort: "Book",
  homeAria: "GetTaxcy home",
  stores: {
    "google-play": { kicker: "Get it on", label: "Google Play" },
    "app-store": { kicker: "Download on the", label: "App Store" },
    comingSoon: "Coming soon",
    comingSoonLine: "The app is coming soon to Google Play and the App Store.",
  },
  banner: {
    text: "GetTaxcy app coming soon to Google Play and the App Store –",
    link: "book now on WhatsApp",
  },
  hero: {
    location: "Paphos · All Cyprus",
    title: "Go anywhere in Cyprus",
    text: "Fixed-price taxis and airport transfers across Cyprus, 24/7.",
    whatsappLink: "Or book on WhatsApp",
    collage: {
      ready: "Ready to travel?",
      airport: "Travellers with luggage in an airport terminal",
      car: "Taxi roof sign lit up at night",
      town: "Paphos lighthouse, Cyprus",
    },
    subtitle: "Fixed-price taxis and airport transfers from Larnaca, Paphos and Ercan — to anywhere on the island, 24/7.",
    rideLink: "Need a ride today? Book on WhatsApp",
    imgAlt: "Coastal road in Paphos, Cyprus",
    chipFixed: "Fixed price, agreed upfront",
  },
  booking: {
    pickup: "Pick-up location",
    pickupPh: "e.g. Paphos Airport",
    dropoff: "Drop-off location",
    dropoffPh: "e.g. Limassol, hotel name",
    date: "Date",
    time: "Time",
    passengers: "Passengers",
    submit: "Get price on WhatsApp",
    error: "Please enter a pick-up and drop-off location.",
    asap: "As soon as possible",
    msg: { intro: "Hello GetTaxcy, I'd like a price for a ride.", pickup: "Pick-up", dropoff: "Drop-off", when: "Date/time", pax: "Passengers" },
  },
  services: {
    title: "Explore what you can do with GetTaxcy",
    details: "Details",
    bookMsg: "Hello GetTaxcy, I'd like details about: ",
    items: [
      { id: "airport", title: "Airport transfers", text: "Larnaca, Paphos and Ercan airports, with meet & greet in arrivals." },
      { id: "long", title: "Long-distance trips", text: "Fixed-price rides between any towns across Cyprus." },
      { id: "minibus", title: "Minibus 6–9 & 12+", text: "6–9 seaters and 12+ seat minibuses for families and groups." },
      { id: "north", title: "North Cyprus", text: "Trips to and from North Cyprus. Price on request." },
      { id: "business", title: "Business accounts", text: "Regular rides for your company, staff and guests. Contact us to set up an account." },
    ],
  },
  marqueeAria: "Destinations we serve",
  marquee: ["Paphos Airport", "Larnaca Airport", "Ercan Airport", "Limassol", "Nicosia", "Ayia Napa", "Troodos", "Long-distance trips", "24/7 across Cyprus"],
  how: {
    title: "How to request a ride",
    appSteps: [
      { title: "Download the app", text: "Install GetTaxcy from Google Play or the App Store." },
      { title: "Set pick-up and drop-off", text: "See your fixed price before you confirm the ride." },
      { title: "Your driver arrives", text: "Follow your licensed driver live until they reach you." },
    ],
    text: "Book, follow your driver live, and ride. No haggling, no surprises — just a licensed Paphos taxi company behind every trip.",
    steps: [
      { n: "01", title: "Book", text: "Enter your pickup and destination and confirm your fixed price before you go." },
      { n: "02", title: "Track your driver", text: "See your licensed driver on the way to you. At the airport, they wait in arrivals with your name sign." },
      { n: "03", title: "Ride", text: "Sit back in a clean sedan, 6–9 seater or minibus and ride anywhere across Cyprus." },
    ],
  },
  why: {
    eyebrow: "Why GetTaxcy",
    title: "A local taxi company,",
    titleAccent: "in your pocket.",
    price: { title: "Fixed prices", text: "Your fare is agreed before the ride. What you see is what you pay." },
    greet: {
      sign: "Mr. & Mrs. You",
      title: "Airport meet & greet",
      text: "At Larnaca, Paphos and Ercan, your driver waits in arrivals holding a sign with your name.",
      alt: "GetTaxcy driver holding a name sign in the airport arrivals hall",
    },
    clock: { title: "Day or night", text: "Early flights, late landings — we drive around the clock." },
    island: {
      title: "All of Cyprus",
      text: "From short city hops to long-distance trips coast to coast.",
      places: ["Paphos", "Limassol", "Larnaca", "Nicosia", "Ayia Napa", "Ercan", "Polis", "Troodos"],
    },
    fleet: {
      title: "A car for every crew",
      items: [
        { name: "Sedans", seats: "1–4" },
        { name: "6–9 seaters", seats: "6–9" },
        { name: "Minibuses", seats: "Groups" },
      ],
    },
  },
  ride: {
    kicker: "Can't wait for the app?",
    title1: "Need a ride",
    title2: "now?",
    text: "Message or call Costataxicy and we'll confirm your driver and fixed price straight away.",
    whatsapp: "Book on WhatsApp",
    call: "Call now",
    website: "Visit our main website costataxicy.com",
  },
  faq: {
    eyebrow: "FAQ",
    title: "Good to know.",
    items: [
      {
        q: "How are prices calculated?",
        a: "Every GetTaxcy ride has a fixed price agreed before you travel, so the fare you see is the fare you pay. Send us your pickup and destination on WhatsApp or call for a quote.",
      },
      {
        q: "How does airport pickup work?",
        a: "We pick up at Larnaca, Paphos and Ercan airports. Your driver meets you in the arrivals hall holding a sign with your name and helps you to the car.",
      },
      { q: "How can I pay?", a: "We accept cash and card. Your price is fixed and agreed when you book, so there are no surprises at the end of the ride." },
      {
        q: "When will the GetTaxcy app be available?",
        a: "The GetTaxcy app is coming soon to Google Play and the App Store. Until then, book instantly on WhatsApp or by phone at +357 99940234.",
      },
      {
        q: "Can I book a large vehicle or a long-distance trip?",
        a: "Yes. Choose from sedans, 6–9 seaters and minibuses, for short city hops or long-distance trips anywhere in Cyprus.",
      },
    ],
  },
  footer: {
    about: "GetTaxcy is run by Costataxicy, a licensed taxi company in Paphos serving all of Cyprus.",
    company: "Company",
    address1: "Diagorou 20",
    address2: "Paphos 8042, Cyprus",
    phone: "Phone / WhatsApp",
    chat: "Chat on WhatsApp",
    email: "Email",
    rights: "All rights reserved.",
  },
};
